<template>
  <div class="overlay"
       :class="{active: event}"
       @click="onClickClose"
  >
    <div v-if="event" ref="page" class="page">
      <div class="container" @click.stop="null">
        <span class="icon icon-cross" @click="onClickClose" />
        <div class="category-bar" :style="{backgroundColor: event.category.bgColor}" />
        <div class="main-content">
          <div class="column column-1">
            <a class="link" target="_blank" :href="`./files/${event.photo}`">
              <img
                :src="`./files/${event.photo}`"
                class="poster"
              >
            </a>
          </div>

          <div class="column column-2">
            <h1>
              {{ $filters.translate(event.title) }}
            </h1>
            <template v-for="field in fields">
              <section v-if="hasValue(field)">
                <label>
                  {{ $filters.translate(field.label) }}
                </label>
                <p :class="{isLink: field.isLink}">
                  <teamplate v-if="field.isLink">
                    <a class="link" target="_blank" :href="get(event, field.field)" v-html="get(event, field.field)" />
                  </teamplate>
                  <template v-else>
                    <span v-html="field.fieldFunction? field.fieldFunction(event): get(event, field.field)" />
                  </template>
                </p>
              </section>
            </template>
            <div v-if="$filters.translate(event.regUrl)" class="register-button-container">
              <a :href="$filters.translate(event.regUrl)" target="_blank">
                <div class="register-button">
                  {{ $filters.translate('T_REGISTER') }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Base from '@/components/Base'
import OverlayService from '@/services/OverlayService'
import _ from 'lodash'
import moment from 'moment'

export default {
  mixins: [
    Base
  ],
  props: [
    'event'
  ],
  data () {
    return {
      isEmpty: _.isEmpty,
      isFunction: _.isFunction,
      get: _.get,
      fields: []
    }
  },
  mounted () {
    this.fields = [
      {
        label: 'T_DATE',
        fieldFunction: this.getEventDateText
      },
      {
        label: 'T_TIME',
        fieldFunction: this.getTimeText
      },
      {
        label: 'T_VENUE',
        field: 'location',
        fieldFunction: this.getVenueText
      },
      {
        label: 'T_SPEAKERS',
        field: 'speakers',
        fieldFunction: this.getSpeakersText
      },
      {
        label: 'T_LANGUAGE',
        field: 'lang',
        fieldFunction: this.getLangText
      },
      {
        label: 'T_ENQUIRY',
        field: ['enq', 'enqTel', 'enqEmail'],
        fieldFunction: this.getEnquiryText
      },
      {
        label: 'T_WEBSITE',
        field: 'website',
        isLink: true
      },
      {
        label: 'T_AUDIENCE',
        field: 'openStatus',
        fieldFunction: this.getAudienceText
      },
      {
        label: 'T_REMARKS',
        field: 'remarks',
        fieldFunction: this.getRemarkText
      },
      {
        label: 'T_ORGANISERS',
        field: 'organisers',
        fieldFunction: this.getOrganisersText
      },
      {
        label: 'T_ZOOM_ONLINE',
        field: 'zoomLink',
        isLink: true
      }
    ]
  },
  methods: {
    getMonthText () {
      const month = _.toUpper(moment(this.selected.date).format('MMMM'))
      return this.$filters.translate(`T_${month}`)
    },
    onChangeSelected () {
      this.$emit('update:selected', this.selected)
      this.$emit('change', this.selected)
    },
    getTimeText (event) {
      if (event.isFull === 'F') {
        return this.$filters.translate('T_FULL_DAY')
      } else {
        return _.uniq(_.compact([
          _.compact([event.timeFrom, event.timeTo]).join(':'),
          _.compact([event.timeFrom2, event.timeTo2]).join(':')
        ])).join(' - ')
      }
    },
    getSpeakersText (event) {
      return _.map(event.speakers, speaker => {
        return _.compact([
          this.$filters.translate(speaker.name),
          this.$filters.translate(speaker.title)
        ]).join(', ')
      }).join('<br>')
    },
    getOrganisersText (event) {
      return _.map(event.organisers, organiser => {
        return this.$filters.translate(organiser.name)
      }).join(', ')
    },
    getVenueText (event) {
      return _.compact([
        this.$filters.translate(event.locationOther),
        this.$filters.translate(_.get(event, 'location.name')),
        this.$filters.translate(_.get(event, 'location.campus.name'))
      ]).join(', ')
    },
    getEnquiryText (event) {
      let value = this.$filters.translate(event.enq)
      if (_.isString(value)) {
        value = value.replace(/\r?\n/g, '<br />')
      }

      return _.compact([
        value,
        event.enqTel,
        event.enqEmail
      ]).join('<br>')
    },
    onClickClose () {
      OverlayService.setEvent(null)
    },
    getAudienceText (event) {
      const list = _.get(event, 'openStatus').split(',')
      return _.map(list, key => {
        return this.$filters.translate(`T_AUDIENCE_${_.toUpper(key)}`)
      }).join(', ')
    },
    getLangText (event) {
      const list = _.get(event, 'lang').split(',')
      return _.map(list, key => {
        if (key === 'Others') {
          return this.$filters.translate(event.langOther)
        } else {
          return this.$filters.translate(`T_${_.toUpper(key)}`)
        }
      }).join(', ')
    },
    getRemarkText (event) {
      let value = this.$filters.translate(event.remarks)
      value = (value || '').replace(/\r?\n/g, '<br />')
      return value
    },
    hasValue (field) {
      if (!field.field) {
        return true
      }
      if (_.isArray(field.field)) {
        return _.some(field.field, key => {
          return !_.isEmpty(_.get(this.event, key))
        })
      } else {
        return !_.isEmpty(_.get(this.event, field.field))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/_variables.scss';

.overlay {
  overflow: hidden;
  z-index: 10;
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  height: -webkit-fill-available;
  background-color: rgba(black, 0.4);
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.4s;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &.active {
    pointer-events: all;
    opacity: 1;
  }

  .page {
    margin-right: 110px;
    margin-top: 50px;
    margin-bottom: 50px;
    min-width: calc(1280px - 220px);
    width: calc(100vw - 190px - 110px - 50px);
    max-height: calc(100% - 100px);
    overflow-y: auto;

    // height: 895px;
    .container {
      position: relative;
      padding: 78px;
      background-color: #F5F8FA;
    }
    .main-content {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;
      .poster {
        width: 462px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
      }

      .column-2 {
        display: block;
        padding-left: 40px;
        width: calc(100% - 462px);
        // border: 1px red solid;

        h1 {
          font-family: Poppins-Bold;
          color: $color-hkbu-blue-background;
          font-size: 20px;
          line-height: 30px;
        }

        section {
          margin-top: 20px;
          label {
            font-family: Poppins-Medium;
            font-size: 18px;
            line-height: 27px;
            color: #1F4283;
          }
          p {
            font-size: 16px;
            line-height: 24px;

            &.isLink {
              a {
                word-wrap: break-word;
              }
            }
          }
        }
      }

    }

    .category-bar {
      // background-color: red;
      // opacity: 0.5;
      width: 16px;
      height: 100%;
      position: absolute;
      right: 0px;
      top: 0px;
    }
  }

  .icon {
    position: absolute;
    left: 16px;
    top: 16px;
    display: inline-block;
    min-width: 18px;
    width: 18px;
    height: 18px;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
    &.icon-cross {
      background-image: url('@/assets/icon-cross.png');
    }
  }

  .link {
    color: $color-hkbu-blue-background;
    text-decoration: none;
    &:hover {
      color: $color-light-blue-background;
    }
  }

  .register-button {
    // width: 187px;
    background-color: $color-hkbu-blue-background;
    color: white;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    padding: 8px 60px;
    border-radius: 20px;
    display: inline-block;
    margin-top: 50px;

    &:hover {
      background-color: $color-light-blue-background;
    }
  }
}

@media screen and (min-width: 1800px)
{
  .overlay {
    .page {
      margin-right: $main-content-1800-padding-right;
      min-width: 100px;
      width: calc(100vw - #{$main-content-1800-padding-right} - 190px);
      // width: 100px;
      // width: calc(100vw - 190px - 110px - 50px);
    }
  }
}

@media screen and (max-width: 1280px)
{
  .overlay {
    .page {
      margin-right: 50px;
      min-width: auto;
      width: calc(100vw - 115px);
      .category-bar {
        width: 14px;
      }

      .main-content {
        .poster {
          width: calc(462px * 0.7);
          background-size: contain;
        }

        .column-2 {
          width: calc(100% - 462px * 0.7);
          h1 {
            font-size: 18px;
            line-height: 27px;
          }
          section {
            margin-top: 16px;
            label {
              font-size: 16px;
              line-height: 24px;
            }
            p {
              font-size: 14px;
              line-height: 21px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px)
{
  .overlay {
    .page {
      margin-right: 25px;
      min-width: auto;
      width: calc(100vw - 55px);
      .container {
        padding: 20px;
        padding-top: 80px;
      }
      .category-bar {
        width: 14px;
      }

      .main-content {
        flex-direction: column;
        .poster {
          width: 100%;
          background-size: contain;
        }
        .column-2 {
          margin-top: 60px;
          padding: 0px;
          width: 100%;
          h1 {
            font-size: 18px;
            line-height: 27px;
          }
          section {
            margin-top: 16px;
            label {
              font-size: 16px;
              line-height: 24px;
            }
            p {
              font-size: 14px;
              line-height: 21px;
            }
          }
        }
      }
    }
    .register-button-container {
      width: 100%;
      display: flex;
      justify-content: center;
    }

  }
}
</style>
